<template>
  <div style="height: 100%">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
    <keep-alive>
      <router-view v-if="isRouterAlive"></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "K_app",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      lang: "",
      // keepAlivePage: [
      //   "topicIndex",
      //   "identityIndex",
      //   "mutualVisits",
      //   "importVisit",
      //   "exportVisit",
      //   "analysis",
      //   "partner",
      //   "CooperationProjects",
      //   "IntelligenceProject",
      //   "PartnerAgencies",
      // ],
    };
  },
  beforeCreate() {
    var link = window.location.href;
    if (link.indexOf("/en") != -1) {
      this.$cookie.delete("lang");
      this.$cookie.set("lang", "en", {
        expires: "1h",
      });
    } else {
         this.$cookie.delete("lang");
    }
  },
  created() {
    console.log(this.$cookie.get("lang"));
  },
  computed: {},
  watch: {
    $route: {
      handler: function (val, oldVal) {
        // if(val.name == 'Main'){
        //   this.keepAlivePage = []
        // }else{
        //   this.keepAlivePage = ['topicIndex','identityIndex','mutualVisits','importVisit','exportVisit','analysis','partner','CooperationProjects','IntelligenceProject','PartnerAgencies']
        // }
        // if(oldVal.name == 'Main'){
        //   this.keepAlivePage = []
        // }else{
        //   this.keepAlivePage = ['topicIndex','identityIndex','mutualVisits','importVisit','exportVisit','analysis','partner','CooperationProjects','IntelligenceProject','PartnerAgencies']
        // }
        // this.keepAlivePage = this.$store.state.keepAlivePage;
      },
      // 深度观察监听
      deep: true,
    },
  },
  mounted() {
    //    var link = window.location.href;
    //   if (link.indexOf("/en") != -1) {
    //     this.$cookie.set("lang", "en", {
    //       expires: "1h",
    //     });
    //   } else {
    //     this.$cookie.delete("lang");
    //   }
    // this.lang = this.$cookie.get('lang')
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
  },
};
</script>

<style lang="less" scoped>
// @import "./assets/css/global/index.less";

.el-select-dropdown__item.selected {
  color: #ff3a25 !important;
}
.pagination {
  a {
    font-size: 12px;
  }
}
</style>
